/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { permissionsLlmRevoke } from "../../funcs/permissionsLlmRevoke.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.LlmRevokeRequest$inboundSchema,
};

export const tool$permissionsLlmRevoke: ToolDefinition<typeof args> = {
  name: "permissions-llm-revoke",
  description: `Revoke permission from a user or remove public access

Revoke a role from a user for a resource, or remove public access by using "*" as userId. Only owners can revoke permissions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await permissionsLlmRevoke(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
